export default Object.freeze({
  currencies: [
    {
      display: 'EUR (€)',
      code: 'EUR',
      multiplier: 100,
    },
    {
      display: 'USD ($)',
      code: 'USD',
      multiplier: 100,
    },
    {
      display: 'CHF (CHF)',
      code: 'CHF',
      multiplier: 100,
    },
    {
      display: 'GBP (£)',
      code: 'GBP',
      multiplier: 100,
    },
    {
      display: 'CAD ($)',
      code: 'CAD',
      multiplier: 100,
    },
    {
      display: 'AUD ($)',
      code: 'AUD',
      multiplier: 100,
    },
  ],
});
